import { defineContent } from './defineContent.js';
import data from './ourDream.json';
import { ourDreamSchema } from './ourDream.schema.js';

export const ourDream = defineContent(ourDreamSchema, data);
